import { AbstractProcessingStrategyEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/entities/ProcessingStrategy/AbstractProcessingStrategyEntity';
import { ParallelProcessingStrategyEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/entities/ProcessingStrategy/ParallelProcessingStrategyEntity';
import { WaterfallProcessingStrategyEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/entities/ProcessingStrategy/WaterfallProcessingStrategyEntity';
import { AbstractLoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/entities/PaymentMethodDetail/AbstractLoanPaymentMethodDetailEntity';

const ProcessingStrategies = [WaterfallProcessingStrategyEntity, ParallelProcessingStrategyEntity];

export class ProcessingStrategyFactory {
  public static create(
    paymentMethodDetailEntity: AbstractLoanPaymentMethodDetailEntity,
  ): AbstractProcessingStrategyEntity {
    if (!paymentMethodDetailEntity.processingStrategy?.type) {
      return new ParallelProcessingStrategyEntity(paymentMethodDetailEntity);
    }

    for (const strategy of ProcessingStrategies) {
      if (strategy.isType(paymentMethodDetailEntity.processingStrategy.type)) {
        return new strategy(paymentMethodDetailEntity);
      }
    }

    throw new Error('No processing strategy found');
  }
}
